module.exports = __webpack_public_path__ + "static/media/udemy-mern.9f8dcf06.jpg";